import {
  BlockStack,
  Box,
  Button,
  Card,
  Checkbox,
  DataTable,
  Form,
  FormLayout,
  InlineStack,
  InlineGrid,
  Layout,
  Select,
  Text,
  TextField,
} from '@shopify/polaris'
import { useTranslation } from 'react-i18next'

import * as Pages from '../../../../constants/page'
import * as WidgetsList from '../../../../constants/widgets'
import TranslationModal from '../../../../components/TranslationsModal'

export default function Details({
  form,
  page = 'create',
  dashboardData,
  pricing,
}) {
  const { t } = useTranslation()
  const shopifyPageList = Object.values(Pages).map((page) => ({
    value: page.value,
    label: page.label,
  }))
  const activeWidget = Object.values(WidgetsList)
    .map((widget) => ({
      value: widget.value,
      title: widget.label,
      subtitle: widget.description,
      icon: widget.icon,
    }))
    .filter((widget) => widget.value === form.fields.widgetType.value)[0]

  return (
      <Card id="details">
        <FormLayout>
          <FormLayout>
            <BlockStack
              alignItems="end"
              columns={page === 'create' ? '1fr' : '1fr auto'}
              gap={'300'}
            >
              <TextField
                autoComplete="text"
                type="text"
                minLength={3}
                {...form.fields.name}
                label={
                  page == 'create'
                    ? t('Section.Create.Form.Name.title')
                    : t('Section.Edit.Sections.Details.name')
                }
                placeholder={t('Section.Create.Form.Name.placeholder')}
              />
              {page != 'create' && (
                <InlineStack blockAlign='center' gap='100'>
                  <TranslationModal
                    translationField={form.fields.translations}
                    dashboardData={dashboardData}
                    pricing={pricing}
                    primaryTextField={form.fields.sectionTitle}
                  />
                <Text as='strong' variant='bodyMd'>for Title text</Text>
                </InlineStack>
              )}
            </BlockStack>
          </FormLayout>
          <FormLayout.Group>
            <TextField
            disabled={true}
              value={form.fields.experience.value}
              placeholder={t('Section.Create.Form.Experience.placeholder')}
              label={t('Section.Create.Form.Experience.title')}
            />
          </FormLayout.Group>
        </FormLayout>
      </Card>
  )
}

const RecommendationTypeCard = ({
  title,
  subtitle,
  checked,
  onClick,
  icon,
}) => {
  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Checkbox checked={checked} onChange={onClick} />
        <img src={icon} width={32} height={32} alt="icon" />
        <div
          style={{
            display: 'flex',
            flex: '1 1 0%',
            paddingLeft: 'var(--p-space-400)',
          }}
        >
          <BlockStack>
            <Text as="h6" fontWeight="semibold">
              {title}
            </Text>
            <Text as="p">{subtitle}</Text>
          </BlockStack>
        </div>
      </div>
    </div>
  )
}
